import styled from "styled-components";
import {
  Button,
  buttonThemes,
  colors,
  screenSizes,
  typography
} from "@streeteasy/design-system";
import { Form as FormikForm } from "formik";

import TermsMessageBase from "../TermsMessage";

const { Caption } = typography;
const { GRAY_LIGHT, TEXT_SECONDARY, WHITE } = colors;
const { LARGE_SCREEN } = screenSizes;

export const Form = styled(FormikForm)`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  margin-bottom: 0;

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    height: auto;
  }
`;

export const TermsMessage = styled(TermsMessageBase)`
  border-top: 1px solid ${GRAY_LIGHT};
  margin-top: 16px;
  padding-top: 16px;
`;

export const ButtonContainer = styled.div`
  background-color: ${WHITE};
  border-top: 1px solid ${GRAY_LIGHT};
  bottom: 0;
  column-gap: 16px;
  display: flex;
  margin-top: 42px;
  padding: 16px 0;
  position: sticky;
`;

export const FormContainer = styled.div``;

export const FieldContainer = styled.div`
  margin-bottom: 18px;
`;

export const CancelButton = styled(Button).attrs({
  theme: buttonThemes.SECONDARY
})`
  min-width: 122px;
`;

export const SubmitButton = styled(Button)`
  flex: 1;
`;

export const BrokerageAddress = styled(Caption)`
  color: ${TEXT_SECONDARY};
  text-align: center;
`;
